import type { Content, ContentRelationshipField } from '@cobliteam/prismic';

export function isHomeBannerItemDocument(
  item: ContentRelationshipField<'home_banner_item'> | undefined
): item is ContentRelationshipField<'home_banner_item'> & Content.HomeBannerItemDocument {
  return !!item && 'data' in item && typeof item.data === 'object';
}
